import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { RegistreService } from '../registre.service';
import { Registre } from '../registre.interface';
import { helper } from 'src/environments/helper';

@Component({
    selector: 'app-change-current-number',
    templateUrl: './change-current-number.component.html',
    styleUrls: ['./change-current-number.component.scss']
})
export class ChangeCurrentNumberComponent {
    // general error
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    token!: string;
    isLoading = false;
    helper = helper;

    form: FormGroup = new FormGroup({
        current_number: new FormControl(this.data.current_number, [Validators.required]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: Registre,
        private dialogRef: MatDialogRef<ChangeCurrentNumberComponent>,
        private notificationService: NotificationService,
        private authService: AuthService,
        private registreService: RegistreService,
    ) {
        this.processToken();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.registreService.setToken(token);
        });
    }

    submitForm() {
        this.isLoading = true;

        const { current_number } = this.form.value;
        const changedCurrentNumber = {
            current_number
        };

        this.registreService
            .changeCurrentNumber(this.data.id, changedCurrentNumber)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    onHttpError(res: any) {
        if (res.errors && res.errors.message && res.errors.message.length > 0) {
            res.errors.message.forEach((msg: string) => {
                this.notificationService.warningSwal(
                    this.errorTitle,
                    msg,
                    this.errorIcon
                );
            });
        } else {
            let msg;
            try {
                // try to catch the message from server
                msg = res.error.errors.message[0];
            } catch (error) {
                // controll output message
                msg = helper.dialogConfig.generalMessages.error;
            }
            this.notificationService.warningSwal(
                this.errorTitle,
                msg,
                this.errorIcon
            );
        }
    }
}
